import { AchievementResponse } from '../models/response/AchievementResponse'
import { RatingResponse } from '../models/response/RatingResponse'
import { api } from './api'

export default class AccomplishmentsService {

    static async getAchievements(): Promise<AchievementResponse> {
        const response = await api.get('/user/achievement/achievements', { });
        return response.data as AchievementResponse;
    }

    static async getRating(): Promise<RatingResponse> {
        const response = await api.get('/user/achievement/rating', { });
        return response.data as RatingResponse;
    }
} 